import { useScroll } from "framer-motion"
import { useMemo, useRef } from "react"

type UseScrollOptions = Parameters<typeof useScroll>[0]
type UseScrollAppOptions = Omit<UseScrollOptions, "container">
type UseScrollReturn = ReturnType<typeof useScroll>

// A wrapper around framer-motion's useScroll that automatically sets
// the container to be the main scrollable area of the app.
export function useScrollApp(options?: UseScrollAppOptions): UseScrollReturn {
  const containerRef = useRef<HTMLDivElement>(
    useMemo(() => document.querySelector(".App > .ScrollView")!, [])
  )

  return useScroll({
    container: containerRef,
    offset: ["start end", "end start"],
    ...options
  })
}
